import type { ErrorInfo, ReactNode } from 'react'
import React, { Suspense, useCallback } from 'react'

import { captureReactException } from '../../sentry'

import ErrorBoundary from './ErrorBoundary'

interface OwnProps {
  readonly children: ReactNode
  // Rendered when the lazy chunk fails to load or throws.
  readonly fallback?: ReactNode
  // Rendered by Suspense while the lazy chunk is loading.
  readonly loading?: ReactNode
}

const SuspenseWithCatch = ({ children, fallback, loading }: OwnProps) => {
  const handleError = useCallback((error: Error, info: ErrorInfo) => {
    captureReactException(error, info)
  }, [])

  return (
    <ErrorBoundary fallback={fallback} onError={handleError}>
      <Suspense fallback={loading}>{children}</Suspense>
    </ErrorBoundary>
  )
}

export default SuspenseWithCatch
